import {
    borders as delonghiBorders,
    colors as delonghiColors,
    radius as delonghiRadius,
    shadows as delonghiShadows,
    spacing as delonghiSpacing,
    iconsSize as delonghiIconsSize,
    fontWeights as delonghiFontWeights,
} from '../_delonghi'

import {
    borders as kenwoodBorders,
    colors as kenwoodColors,
    radius as kenwoodRadius,
    shadows as kenwoodShadows,
    spacing as kenwoodSpacing,
    iconsSize as kenwoodIconsSize,
    semanticOverrides as kenwoodSemanticOverrides,
    fontWeights as kenwoodFontWeights,
} from '../_kenwood'

import {
    borders as nutribulletBorders,
    colors as nutribulletColors,
    radius as nutribulletRadius,
    shadows as nutribulletShadows,
    spacing as nutribulletSpacing,
    iconsSize as nutribulletIconsSize,
    fontWeights as nutribulletFontWeights,
    semanticOverrides as nutribulletSemanticOverrides,
} from '../_nutribullet'

import {
    borders as braunBorders,
    colors as braunColors,
    radius as braunRadius,
    shadows as braunShadows,
    spacing as braunSpacing,
    iconsSize as braunIconsSize,
    semanticOverrides as braunSemanticOverrides,
    fontWeights as braunFontWeights,
} from '../_braun'

import {Semantics} from '../types/semantics.types'

const delonghiSemantics: Semantics = {
    colors: delonghiColors,
    borders: delonghiBorders,
    radius: delonghiRadius,
    shadows: delonghiShadows,
    spacing: delonghiSpacing,
    iconsSize: delonghiIconsSize,
    fontWeights: delonghiFontWeights,
    semanticOverrides: {},
}

const kenwoodSemantics: Semantics = {
    colors: kenwoodColors,
    borders: kenwoodBorders,
    radius: kenwoodRadius,
    shadows: kenwoodShadows,
    spacing: kenwoodSpacing,
    iconsSize: kenwoodIconsSize,
    semanticOverrides: kenwoodSemanticOverrides,
    fontWeights: kenwoodFontWeights,
}

const nutribulletSemantics: Semantics = {
    colors: nutribulletColors,
    borders: nutribulletBorders,
    radius: nutribulletRadius,
    shadows: nutribulletShadows,
    spacing: nutribulletSpacing,
    iconsSize: nutribulletIconsSize,
    fontWeights: nutribulletFontWeights,
    semanticOverrides: nutribulletSemanticOverrides,
}

const braunSemantics: Semantics = {
    colors: braunColors,
    borders: braunBorders,
    radius: braunRadius,
    shadows: braunShadows,
    spacing: braunSpacing,
    iconsSize: braunIconsSize,
    semanticOverrides: braunSemanticOverrides,
    fontWeights: braunFontWeights,
}

export {delonghiSemantics, kenwoodSemantics, nutribulletSemantics, braunSemantics}
